import {NodeAvailabilityType} from '../workspaceReservation';
import {ParkingNode} from './types';

export const groupParkingNodesByAvailability = (parkingNodes: ParkingNode[]) => {
  const init: {[key in NodeAvailabilityType]: ParkingNode[]} = {Available: [], Unavailable: []};

  return parkingNodes.reduce((acc, curr) => {
    const currentType = curr.nodeAvailability;
    const valuesForCurrentType = acc[curr.nodeAvailability];
    return {
      ...acc,
      [currentType]: [...valuesForCurrentType, curr],
    };
  }, init);
};
